import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { PortfolioReportParam } from '../PortfolioReportParam/PortfolioReportParam';
import { usePortfolioReportParamsQuery } from '../../api/usePortfolioReportParamsQuery';
import { Alert } from '../../../CommonComponents/OPL/Alert/Alert';

export const PortfolioReportParams: React.FC = () => {
  const { isLoading, isError, refetch, data } = usePortfolioReportParamsQuery();

  if (isLoading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" mt="24">
        <Loading size="large" />
      </Box>
    );
  }

  if (isError) {
    return (
      <Alert
        variant="error"
        title="Loading Failed"
        message="There was an error loading this report"
        actions={[{ text: 'Try again', action: refetch }]}
        mt="24"
      />
    );
  }

  if (!data) {
    return null;
  }

  const { params, order } = data;

  return (
    <>
      {order.map(paramId => (
        <PortfolioReportParam key={paramId} param={params[paramId]} />
      ))}
    </>
  );
};
